import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type EmailBlackProps = React.HTMLAttributes<HTMLDivElement> & {};

export const EmailBlack: React.FC<EmailBlackProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/email-black.svg"} alt="" />
    </div>
  );
};